import '.d{display:flex;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.d9{background:var(--palette-white);}.ssr-plugin'
import '.an{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.b0{max-width:77.5rem;}.ssr-plugin'
import '.fh{justify-content:stretch;}.ssr-plugin'
import '.br{position:sticky;}.ssr-plugin'
import '.bs{top:0px;}.ssr-plugin'
import '.bt{z-index:10;}.ssr-plugin'
import '.fi{padding-block:1rem;}.ssr-plugin'
import '.fj{height:3rem;}.ssr-plugin'
import '.bi{justify-content:space-between;}.ssr-plugin'
import '.bk{flex-wrap:wrap;}.ssr-plugin'
import '.fk{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ep{margin-top:2rem;}.ssr-plugin'
import '.hg{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d a2 ab e d9"
      >
        <div className="an d r ab e"
        >
          <div className="b0 d e fh br bs bt"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fi fj d bi r bk"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fk d e a2 ep hg b0"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
